import { on } from '../utils/_fn';
import { windowStore } from '../stores/window-store';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

export function initHeader() {
  const html = document.documentElement;

  // 使用 windowStore 取得視窗狀態
  let { ww, wh } = windowStore.getState();

  // 訂閱 windowStore 狀態變化
  windowStore.subscribe((state) => {
    ww = state.ww;
    wh = state.wh;
  });

  /* ---------------------------------------- [START] 選單下滑更改樣式 */
  const header = document.querySelector('#header');
  if (header) {
    const headerClassScroll = 'is-collapse';
    const headerClassScrollDown = 'is-scroll-down';
    const headerClassScrollUp = 'is-scroll-up';
    // 方向判定的死區，避免 layout shift / 位址列收合等微小抖動造成 up/down 來回切換
    const SCROLL_DIR_THRESHOLD = 5;

    // 使用 windowStore 取得滾動位置
    let { ws } = windowStore.getState();
    let windowScrollTopCache = ws;
    let windowScrollStatus = null;

    /**
     * 更改向上滑動與向下滑動狀態
     * @param {string} dir 滑動方向，輸入['down'|'up']
     */
    function scrollStatusChange(dir) {
      if (windowScrollStatus === dir) {
        return false;
      } else {
        if (dir === 'down') {
          scrollStatusDown(header);
          scrollStatusDown(html);
        } else {
          scrollStatusUp(header);
          scrollStatusUp(html);
        }
        windowScrollStatus = dir;
      }
    }

    function scrollStatusDown(el) {
      el.classList.add(headerClassScrollDown);
      el.classList.remove(headerClassScrollUp);
    }

    function scrollStatusUp(el) {
      el.classList.remove(headerClassScrollDown);
      el.classList.add(headerClassScrollUp);
    }

    /* 滑動主要Function */
    function headerScrollHandler() {
      // 從 windowStore 取得最新的滾動位置
      ws = windowStore.getState().ws;

      // 確認上滑與下滑狀態
      // 只有累積超過 SCROLL_DIR_THRESHOLD 才換方向，並只有真的換方向時才更新 cache
      const delta = ws - windowScrollTopCache;
      if (delta > SCROLL_DIR_THRESHOLD) {
        scrollStatusChange('down');
        windowScrollTopCache = ws;
      } else if (delta < -SCROLL_DIR_THRESHOLD) {
        scrollStatusChange('up');
        windowScrollTopCache = ws;
      }

      // 下滑超過一定高度出現樣式：更改選單樣式、GoTop隱藏出現
      if (ws >= 200) {
        header.classList.add(headerClassScroll);
      } else {
        header.classList.remove(headerClassScroll);
      }
    }

    // 訂閱滾動狀態變化
    on(window, 'load', headerScrollHandler);
    windowStore.subscribe(() => {
      headerScrollHandler();
    });
  }
  /* ---------------------------------------- [END] 選單下滑更改樣式 */

  /* ---------------------------------------- [START] 會員選單 RWD 切換 */
  const memberMenuBtn = document.getElementById('memberMenuBtn');
  const memberMenuWrapper = document.getElementById('memberMenuWrapper');
  const memberMenu = document.getElementById('memberMenu');
  const memberMenuList = document.getElementById('memberMenuList');
  const closeBtn = memberMenu?.querySelector('.main-menu-close');
  const offcanvasHeader = memberMenu?.querySelector('.offcanvas-header');
  const offcanvasBody = memberMenu?.querySelector('.offcanvas-body');

  if (memberMenuBtn && memberMenu && memberMenuWrapper && memberMenuList) {
    let dropdownInstance = null;
    let offcanvasInstance = null;
    let currentMode = null;

    // 初始化 Dropdown (lg 以上)
    function initDropdown() {
      if (currentMode === 'dropdown') return;

      // 如果已存在 offcanvas，先銷毀
      if (offcanvasInstance) {
        offcanvasInstance.hide();
        offcanvasInstance.dispose();
        offcanvasInstance = null;
      }

      // 移除 offcanvas 的點擊事件
      if (memberMenuBtn._offcanvasClickHandler) {
        memberMenuBtn.removeEventListener('click', memberMenuBtn._offcanvasClickHandler);
        memberMenuBtn._offcanvasClickHandler = null;
      }

      // 移除 offcanvas 相關 class
      memberMenu.classList.remove('offcanvas', 'offcanvas-start');

      // 隱藏 offcanvas 專用元素
      memberMenu.classList.add('d-none');
      if (offcanvasHeader) offcanvasHeader.classList.add('d-none');
      if (offcanvasBody) offcanvasBody.classList.add('d-none');

      // 將 memberMenuList 移到 memberMenuWrapper 下（作為按鈕的兄弟）
      memberMenuWrapper.appendChild(memberMenuList);

      // 設定 dropdown 相關 class
      memberMenuWrapper.classList.add('dropdown');
      memberMenuList.classList.add('dropdown-menu-end');
      memberMenuList.style.position = '';
      memberMenuList.style.display = '';

      // 先檢查並移除可能已存在的 Bootstrap 實例
      const existingDropdown = Dropdown.getInstance(memberMenuBtn);
      const existingOffcanvas = Offcanvas.getInstance(memberMenu);

      if (existingDropdown) {
        existingDropdown.dispose();
      }
      if (existingOffcanvas) {
        existingOffcanvas.dispose();
      }

      // 設定按鈕屬性
      memberMenuBtn.classList.add('dropdown-toggle');
      memberMenuBtn.setAttribute('data-bs-toggle', 'dropdown');
      memberMenuBtn.setAttribute('aria-expanded', 'false');
      memberMenuBtn.removeAttribute('data-bs-target');
      memberMenuBtn.removeAttribute('aria-controls');

      // 初始化 Bootstrap Dropdown
      try {
        dropdownInstance = new Dropdown(memberMenuBtn);
      } catch (error) {
        console.error('[ui-header] Dropdown 初始化失敗:', error);
      }

      currentMode = 'dropdown';

      // 手動綁定點擊事件（不使用 data-bs-toggle 避免與 offcanvas 衝突）
      memberMenuBtn.removeAttribute('data-bs-toggle');

      const handleDropdownClick = (e) => {
        e.preventDefault();
        if (dropdownInstance) {
          dropdownInstance.toggle();
        }
      };

      memberMenuBtn.addEventListener('click', handleDropdownClick);

      // 儲存 handler 以便之後移除
      memberMenuBtn._dropdownClickHandler = handleDropdownClick;

      // 點擊外側關閉 dropdown
      const handleClickOutside = (e) => {
        if (!memberMenuWrapper.contains(e.target) && memberMenuList.classList.contains('show')) {
          dropdownInstance.hide();
        }
      };

      document.addEventListener('click', handleClickOutside);

      // 儲存 handler 以便之後移除
      memberMenuBtn._clickOutsideHandler = handleClickOutside;
    }

    // 拖曳關閉功能
    function setupSwipeToClose() {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchCurrentX = 0;
      let isDragging = false;
      let dragDistance = 0;

      const SWIPE_THRESHOLD = 0.5; // 拖曳超過 50% 寬度就關閉
      const MIN_SWIPE_DISTANCE = 50; // 最小拖曳距離（px）

      function handleTouchStart(e) {
        // 只在選單開啟時才啟用拖曳
        if (!memberMenu.classList.contains('show')) return;

        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchCurrentX = touchStartX;
        isDragging = false;
        dragDistance = 0;
      }

      function handleTouchMove(e) {
        if (!memberMenu.classList.contains('show')) return;

        touchCurrentX = e.touches[0].clientX;
        const touchCurrentY = e.touches[0].clientY;
        const deltaX = touchCurrentX - touchStartX;
        const deltaY = touchCurrentY - touchStartY;

        // 判斷是否為水平拖曳（水平移動大於垂直移動）
        if (!isDragging && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
          isDragging = true;
        }

        // 只處理向左拖曳
        if (isDragging && deltaX < 0) {
          dragDistance = Math.abs(deltaX);

          // 阻止頁面滾動
          e.preventDefault();

          // 使用 transform 移動選單
          const translateX = Math.max(deltaX, -memberMenu.offsetWidth);
          memberMenu.style.transform = `translateX(${translateX}px)`;
          memberMenu.style.transition = 'none';
        }
      }

      function handleTouchEnd() {
        if (!memberMenu.classList.contains('show')) return;

        const menuWidth = memberMenu.offsetWidth;
        const shouldClose = dragDistance > menuWidth * SWIPE_THRESHOLD || dragDistance > MIN_SWIPE_DISTANCE;

        if (isDragging && shouldClose) {
          // 關閉選單
          memberMenu.style.transition = 'transform 0.3s ease-out';
          memberMenu.style.transform = `translateX(-100%)`;

          setTimeout(() => {
            if (offcanvasInstance) {
              offcanvasInstance.hide();
            }
            resetMenuPosition();
          }, 300);
        } else {
          // 恢復原位
          resetMenuPosition();
        }

        isDragging = false;
        dragDistance = 0;
      }

      function resetMenuPosition() {
        memberMenu.style.transition = '';
        memberMenu.style.transform = '';
      }

      // 移除舊的監聽器（如果存在）
      memberMenu.removeEventListener('touchstart', handleTouchStart);
      memberMenu.removeEventListener('touchmove', handleTouchMove);
      memberMenu.removeEventListener('touchend', handleTouchEnd);

      // 加入新的監聽器
      memberMenu.addEventListener('touchstart', handleTouchStart, { passive: true });
      memberMenu.addEventListener('touchmove', handleTouchMove, { passive: false });
      memberMenu.addEventListener('touchend', handleTouchEnd, { passive: true });

      // 當選單完全開啟或關閉時，重置位置
      memberMenu.addEventListener('shown.bs.offcanvas', resetMenuPosition);
      memberMenu.addEventListener('hidden.bs.offcanvas', resetMenuPosition);
    }

    // 初始化 Offcanvas (lg 以下)
    function initOffcanvas() {
      if (currentMode === 'offcanvas') return;

      // 如果已存在 dropdown，先銷毀
      if (dropdownInstance) {
        dropdownInstance.hide();
        dropdownInstance.dispose();
        dropdownInstance = null;
      }

      // 移除 dropdown 的點擊事件
      if (memberMenuBtn._dropdownClickHandler) {
        memberMenuBtn.removeEventListener('click', memberMenuBtn._dropdownClickHandler);
        memberMenuBtn._dropdownClickHandler = null;
      }

      // 移除點擊外側關閉事件
      if (memberMenuBtn._clickOutsideHandler) {
        document.removeEventListener('click', memberMenuBtn._clickOutsideHandler);
        memberMenuBtn._clickOutsideHandler = null;
      }

      // 顯示 offcanvas 專用元素
      memberMenu.classList.remove('d-none');
      if (offcanvasHeader) offcanvasHeader.classList.remove('d-none');
      if (offcanvasBody) offcanvasBody.classList.remove('d-none');

      // 將 memberMenuList 移回 offcanvas-body 內
      if (offcanvasBody) {
        offcanvasBody.appendChild(memberMenuList);
      }

      // 移除 dropdown 相關 class
      memberMenuWrapper.classList.remove('dropdown');
      memberMenuBtn.classList.remove('dropdown-toggle');
      memberMenuList.classList.remove('dropdown-menu-end');

      // 設定 offcanvas 相關 class 和樣式
      memberMenu.classList.add('offcanvas', 'offcanvas-start');
      memberMenuList.style.position = 'static';
      memberMenuList.style.display = 'block';

      // 先檢查並移除可能已存在的 Offcanvas 實例
      const existingOffcanvas = Offcanvas.getInstance(memberMenu);
      if (existingOffcanvas) {
        existingOffcanvas.dispose();
      }

      // 設定按鈕屬性 - 不使用 data-bs-toggle，改用手動控制
      memberMenuBtn.removeAttribute('data-bs-toggle');
      memberMenuBtn.removeAttribute('data-bs-target');
      memberMenuBtn.setAttribute('aria-controls', 'memberMenu');
      memberMenuBtn.removeAttribute('aria-expanded');

      // 初始化 Bootstrap Offcanvas
      offcanvasInstance = new Offcanvas(memberMenu, {
        scroll: false,
      });

      // 手動綁定點擊事件
      const handleOffcanvasClick = (e) => {
        e.preventDefault();
        if (offcanvasInstance) {
          offcanvasInstance.toggle();
        }
      };

      memberMenuBtn.addEventListener('click', handleOffcanvasClick);
      memberMenuBtn._offcanvasClickHandler = handleOffcanvasClick;

      // 監聽 offcanvas 開關狀態
      memberMenu.addEventListener('show.bs.offcanvas', handleOffcanvasShow);
      memberMenu.addEventListener('hide.bs.offcanvas', handleOffcanvasHide);

      // 設定拖曳關閉功能
      setupSwipeToClose();

      currentMode = 'offcanvas';
    }

    function handleOffcanvasShow() {
      if (closeBtn) {
        closeBtn.classList.add('is-open');
      }
    }

    function handleOffcanvasHide() {
      if (closeBtn) {
        closeBtn.classList.remove('is-open');
      }
    }

    // 使用 matchMedia 監聽斷點變化
    const lgBreakpoint = window.matchMedia('(min-width: 992px)');

    function handleBreakpointChange(e) {
      if (e.matches) {
        // lg 以上 - 使用 dropdown
        initDropdown();
      } else {
        // lg 以下 - 使用 offcanvas
        initOffcanvas();
      }
    }

    // 初始化檢查
    handleBreakpointChange(lgBreakpoint);

    // 監聽斷點變化
    lgBreakpoint.addEventListener('change', handleBreakpointChange);
  }
  /* ---------------------------------------- [END] 會員選單 RWD 切換 */
}
